import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowRefresh = () => {
  return (
    <g>
      <path d="m1.1851 5.54a.7531.7531 0 0 0 .6921.4634h2.9321a.75.75 0 0 0 0-1.5h-1.1212l.4073-.4072a5.5215 5.5215 0 0 1 9.4258 3.8462.75.75 0 0 0 .75.7422h.0078a.75.75 0 0 0 .7422-.7578 7.0216 7.0216 0 0 0 -11.9863-4.8916l-.4077.4076v-1.1215a.75.75 0 0 0 -1.5 0v2.9317l.001.0048a.75.75 0 0 0 .0569.2822z" />
      <path d="m14.4089 10.055a.75.75 0 0 0 -.2866-.0579h-2.9316a.75.75 0 0 0 0 1.5h1.1211l-.4072.4072a5.5216 5.5216 0 0 1 -9.4259-3.8452.7408.7408 0 0 0 -.7578-.7422.75.75 0 0 0 -.7422.7578 7.0241 7.0241 0 0 0 11.9863 4.89l.4072-.4072v1.1211a.75.75 0 0 0 1.5 0v-2.9315a.753.753 0 0 0 -.4634-.6921z" />
    </g>
  );
};

export default withIcon(IconArrowRefresh);
